/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClaimCollateralHoldingRequest
 */
export interface ClaimCollateralHoldingRequest {
    /**
     * 
     * @type {string}
     * @memberof ClaimCollateralHoldingRequest
     */
    institutionName: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimCollateralHoldingRequest
     */
    accountNumber: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimCollateralHoldingRequest
     */
    street: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimCollateralHoldingRequest
     */
    houseNumber: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimCollateralHoldingRequest
     */
    zipCode: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimCollateralHoldingRequest
     */
    city: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimCollateralHoldingRequest
     */
    country: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ClaimCollateralHoldingRequest
     */
    isValueKnown: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof ClaimCollateralHoldingRequest
     */
    value: number | null;
    /**
     * 
     * @type {Date}
     * @memberof ClaimCollateralHoldingRequest
     */
    valueDate: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimCollateralHoldingRequest
     */
    remarks: string | null;
}

/**
 * Check if a given object implements the ClaimCollateralHoldingRequest interface.
 */
export function instanceOfClaimCollateralHoldingRequest(value: object): value is ClaimCollateralHoldingRequest {
    if (!('institutionName' in value) || value['institutionName'] === undefined) return false;
    if (!('accountNumber' in value) || value['accountNumber'] === undefined) return false;
    if (!('street' in value) || value['street'] === undefined) return false;
    if (!('houseNumber' in value) || value['houseNumber'] === undefined) return false;
    if (!('zipCode' in value) || value['zipCode'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('country' in value) || value['country'] === undefined) return false;
    if (!('isValueKnown' in value) || value['isValueKnown'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('valueDate' in value) || value['valueDate'] === undefined) return false;
    if (!('remarks' in value) || value['remarks'] === undefined) return false;
    return true;
}

export function ClaimCollateralHoldingRequestFromJSON(json: any): ClaimCollateralHoldingRequest {
    return ClaimCollateralHoldingRequestFromJSONTyped(json, false);
}

export function ClaimCollateralHoldingRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimCollateralHoldingRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'institutionName': json['institutionName'],
        'accountNumber': json['accountNumber'],
        'street': json['street'],
        'houseNumber': json['houseNumber'],
        'zipCode': json['zipCode'],
        'city': json['city'],
        'country': json['country'],
        'isValueKnown': json['isValueKnown'],
        'value': json['value'],
        'valueDate': (json['valueDate'] == null ? null : new Date(json['valueDate'])),
        'remarks': json['remarks'],
    };
}

export function ClaimCollateralHoldingRequestToJSON(json: any): ClaimCollateralHoldingRequest {
    return ClaimCollateralHoldingRequestToJSONTyped(json, false);
}

export function ClaimCollateralHoldingRequestToJSONTyped(value?: ClaimCollateralHoldingRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'institutionName': value['institutionName'],
        'accountNumber': value['accountNumber'],
        'street': value['street'],
        'houseNumber': value['houseNumber'],
        'zipCode': value['zipCode'],
        'city': value['city'],
        'country': value['country'],
        'isValueKnown': value['isValueKnown'],
        'value': value['value'],
        'valueDate': value['valueDate'] == null ? value['valueDate'] : `${value['valueDate'].getFullYear()}-${String(value['valueDate'].getMonth()+1).padStart(2,'0')}-${String(value['valueDate'].getDate()).padStart(2,'0')}`,
        'remarks': value['remarks'],
    };
}

